import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import * as loginSelectors from '../../../../../../../root-store/login-store/login.selector';
import { AddTrustTemplateDialogComponent } from '@app/shared/component/add-trust-template-dialog/add-trust-template-dialog.component';
import { AddTrustTemplate } from '@app/shared/component/add-trust-template-dialog/add-trust-template.interfaces';
import { ManageTemplateTypeComponent } from '@app/shared/component/manage-element/manage-template-type/manage-template-type.component';
import {
  ManageExitingTemplateListType,
  ManageTemplateListType,
  TemplateConfigurationListTypes,
} from '@app/shared/component/manage-element/manage-templates/manage-template.interface';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'mx-manage-templates',
  templateUrl: './mx-manage-templates.component.html',
  styleUrl: './mx-manage-templates.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MxManageTemplatesComponent implements OnInit, OnDestroy {
  /* 
    data : Pass List which you want to display
      data = [{
        profile_image_url: null,
        form_name: null,
        type: null,
        vault_user_form_id: null,
        user_id: null
      }]
    placeHolder: PlaceHolder text
    selectedTemplate: pass already selected value
      selectedTemplate: [{
        id: null
      }]
    selectionChange: Method when user select from list
    templateConfigurationList: Pass Template configuration list for create new template
      templateConfigurationList = [{
        label: null,
        id: null,
        type: null
      }]
  */

  @ViewChild('inputField', { read: ElementRef }) inputField: ElementRef<HTMLInputElement>;

  @Input() data = [];
  @Input() placeHolder = '';
  @Input() selectedTemplate: ManageExitingTemplateListType[] = [];
  @Input() templateConfigurationList: TemplateConfigurationListTypes[] = [];
  @Input() isComboInput = false;
  @Input() inlineComponent = false;
  @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onComboInputBlur: EventEmitter<any> = new EventEmitter<any>();
  @Output() openMXPopup: EventEmitter<any> = new EventEmitter<any>();

  subscription = new Subscription();
  connectionUserFormControl = new UntypedFormControl();

  textBoxPlaceHolder: string = 'Search Connections';
  isInputFocused: boolean = false;
  loader: boolean = false;
  disableSearch: boolean = false;
  searchValue = '';
  currentUser;

  constructor(private cd: ChangeDetectorRef, private dialog: MatDialog, private store: Store) {}

  ngOnInit(): void {
    if (Input) {
      this.textBoxPlaceHolder = this.placeHolder;
    }
    this.subscription.add(
      this.store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((result) => {
        if (result) {
          this.currentUser = result;
        }
      })
    );
  }

  onTrustSearch(value) {
    this.connectionUserFormControl.setValue(value);
    this.cd.detectChanges();
  }

  onInputFocus() {
    this.isInputFocused = true;
  }

  connectToMX() {
    this.openMXPopup.emit({});
  }

  onInputBlur() {
    this.isInputFocused = false;
    if (this.onComboInputBlur) {
      this.onComboInputBlur.emit();
    }
  }

  onClearInput() {
    this.connectionUserFormControl.setValue('');
    this.cd.detectChanges();
  }

  selectConnectedUser(user) {
    this.selectionChange.emit(user);
  }

  addNewTemplate(item) {
    if (item.isGroup) {
      const dialogRef = this.dialog.open<ManageTemplateTypeComponent, AddTrustTemplate>(ManageTemplateTypeComponent, {
        data: item.groupList,
      });
      this.subscription.add(
        dialogRef.afterClosed().subscribe(
          (res) => {
            if (res) {
              const groupData = {
                id: res.id,
                label: res.type,
                type: res.type,
                hub_vault_user_form_id: null,
              };
              this.openCreateTrustType(groupData);
            }
          },
          (error) => {}
        )
      );
    } else {
      this.openCreateTrustType(item);
    }
  }

  openCreateTrustType(item) {
    const dialogRef = this.dialog.open<AddTrustTemplateDialogComponent, AddTrustTemplate>(AddTrustTemplateDialogComponent, {
      data: {
        vaultFormId: item.id,
        vault_id: null,
        title: item.label,
        inbox_attachment_id: undefined,
        vaultType: item.type,
        hub_vault_user_form_id: null,
        origin: null,
      },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe(
        (res) => {
          this.selectionChange.emit(res);
        },
        (error) => {}
      )
    );
  }

  onFocusFromParent() {
    setTimeout(() => {
      this.inputField.nativeElement.focus();
      this.isInputFocused = true;
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
